import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs';

import { UserService } from '@services/api/user/user.service';
import { FlatButtonComponent } from '@shared/button/flat-button/flat-button.component';

@Component({
    template: `<div class="p-5">
        <p class="text-lg mb-3">
            Take {{ data.discrepancyCount }} Discrepancies?
        </p>
        @if (isAdmin) {
            You will be taking selected discrepancies to your assignment.
        } @else {
            You will be taking up to {{ data.discrepancyCount }} selected
            discrepancies unless they are already assigned to other users.
        }
        <div class="flex justify-end gap-8 mt-5">
            <app-flat-button (clicked)="cancel()"> Cancel </app-flat-button>
            <app-flat-button variant="cta" (clicked)="take()">
                Take
            </app-flat-button>
        </div>
    </div>`,
    imports: [FlatButtonComponent],
})
export class TakeConfirmDialogComponent implements OnInit {
    isAdmin: boolean = false;

    readonly data: TakeConfirmDialogData = inject(MAT_DIALOG_DATA);
    private readonly dialogRef = inject(
        MatDialogRef<TakeConfirmDialogComponent>,
    );
    private readonly userService = inject(UserService);

    ngOnInit(): void {
        this.setUserPermission();
    }

    private setUserPermission() {
        this.userService
            .isAdminUser()
            .pipe(take(1))
            .subscribe({
                next: (isAdmin) => (this.isAdmin = isAdmin),
            });
    }

    protected cancel() {
        this.dialogRef.close();
    }

    protected take() {
        this.dialogRef.close({ take: true });
    }
}

export interface TakeConfirmDialogData {
    discrepancyCount: number;
}
